import React from "react";
import { Image } from "primereact/image";
import { Link, useLocation } from "react-router-dom";
import { Dock } from "primereact/dock";
import { MenuItem } from "primereact/menuitem";
import { MenuItems } from "../../data/MenuItems";

interface SidebarProps {
  menuItems: MenuItems[];
  isExpanded: boolean;
  setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

const SidebarComponent: React.FC<SidebarProps> = ({
  isExpanded,
  setIsExpanded,
  menuItems,
}) => {
  const location = useLocation();

  // Create dock items for small screens
  const dockItems: MenuItem[] = menuItems.map((item) => ({
    label: item.label,
    icon: () => <i className={`${item.icon} text-xl`}></i>,
    command: () => setIsExpanded(false), // Optional: Close sidebar on item click
    template: (
      <Link
        to={item.path}
        className={`p-2 hover:bg-primary-100 rounded-full transition-all ${
          location.pathname === item.path
            ? "bg-primary-100 text-primary-500"
            : "text-primary-400"
        }`}
      >
        <i className={`${item.icon} text-xl`}></i>
      </Link>
    ),
  }));

  return (
    <>
      {/* Desktop Sidebar */}
      <div
        className={`fixed z-50 top-0 left-0 h-screen shadow-sm hidden md:block bg-white transition-all duration-300 border-e ${
          isExpanded ? "w-64" : "w-24"
        }`}
      >
        <div className="">
          <div
            className={`transition-all duration-300 flex items-center p-4 ${
              isExpanded ? "justify-start" : "justify-center"
            }`}
          >
            <Image
              src={
                isExpanded
                  ? "/assets/images/logo.png"
                  : "/assets/images/logo-icon.png"
              }
              alt="wacepay logo"
              width={isExpanded ? "180" : "50"}
              className="transition-all duration-300"
            />
          </div>
          <div
            className=" overflow-y-auto"
            style={{ maxHeight: "calc(100vh - 100px)" }}
          >
            <div className="flex flex-col gap-6 px-4 py-2">
              {menuItems.map((item, index) => (
                <Link
                  to={item.path}
                  key={index}
                  className={`flex items-center ${isExpanded ? "" : "justify-center"}
                   rounded-lg p-2 text-sm cursor-pointer hover:text-primary-500 transition-colors ${
                     location.pathname === item.path
                       ? "bg-primary-100 text-primary-500"
                       : "text-secondary-500"
                   }`}
                >
                  <i
                    className={`${item.icon} ${isExpanded ? "mr-3" : ""} text-xl`}
                  ></i>
                  {isExpanded && (
                    <span
                      className={`transition-opacity duration-300 ${
                        isExpanded ? "opacity-100" : "opacity-0"
                      }`}
                    >
                      {item.label}
                    </span>
                  )}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Dock for Small Screens */}
      <div className="fixed bottom-0 left-0 right-0 md:hidden z-20 bg-white shadow-lg p-2">
        <Dock
          model={dockItems}
          position="bottom"
          className="p-2 rounded-2xl my-4 bg-black bg-opacity-10"
        />
      </div>
    </>
  );
};

export default SidebarComponent;
